(function () {
  'use strict';

  angular
      .module('tf.retailer.Util')
      .filter('percent', percent);

  // @ngInject
  function percent($filter) {
    var numberFilter = $filter('number');
    return function (value, digits) {
      var formatted = numberFilter(Number(value) * 100, digits);
      if (formatted) {
        formatted += '%';
      }
      return formatted;
    };
  }

})();
